import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { Container, Card, CardBody, Nav, NavItem, NavLink } from "reactstrap"
import classnames from "classnames"
import { withRouter } from "react-router"

import AddBonRetourFournisseur from "./AddBonRetourFournisseur"
import DataTableBonRetourFournisseur from "./DataTableBonRetourFournisseur"
import StatistiqueBonRetourFrs from "./StatistiqueBonRetourFrs"

const BonRetourFournisseur = () => {
    const [perm, setPerm] = useState({
        add: 0,
        delete: 0,
        edit: 0,
        imp: 0,
        view: 0,
    })

    const [section, setSection] = useState(1)

    const back = () => {
        setSection(1)
    }

    // ✅ USEEFFECT UNIQUE ET PROPRE
    useEffect(() => {
        const loadPermissions = () => {
            const userAuth = JSON.parse(localStorage.getItem("userAuth"))

            if (!userAuth?.user?.userData) return

            const userData = userAuth.user.userData

            const subMenu = userData.find(user =>
                user.sous_menus?.some(
                    sm => sm.sous_menu === "Bon retour fournisseur"
                )
            )

            if (!subMenu) return

            const permission = subMenu.sous_menus.find(
                sm => sm.sous_menu === "Bon retour fournisseur"
            )?.permissions?.[0]

            if (!permission) return

            setPerm({
                add: permission.add,
                delete: permission.delete,
                edit: permission.edit,
                imp: permission.imp,
                view: permission.view,
            })
        }

        loadPermissions()
    }, [])

    // ✅ RENDER BLOCK PROPRE
    const renderBlock = () => {
        if (section === 1) {
            return <DataTableBonRetourFournisseur />
        }

        if (section === 2) {
            return perm.add === 1 ? (
                <AddBonRetourFournisseur setSection={setSection} back={back} />
            ) : (
                <h5 className="text-center mt-4 text-danger">
                    {"Vous n'avez pas la permission d'ajouter."}
                </h5>
            )
        }

        if (section === 3) {
            return <StatistiqueBonRetourFrs />
        }

        return null
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>Bon de retour | Cresus</title>
                </MetaTags>

                <Container fluid>
                    <Nav tabs>
                        <NavItem>
                            <NavLink
                                className={classnames({ active: section === 1 })}
                                onClick={() => setSection(1)}
                                style={{ cursor: "pointer" }}
                            >
                                Bon de retour
                            </NavLink>
                        </NavItem>

                        <NavItem>
                            <NavLink
                                className={classnames({ active: section === 2 })}
                                onClick={() => setSection(2)}
                                style={{ cursor: "pointer" }}
                            >
                                Ajouter bon de retour
                            </NavLink>
                        </NavItem>

                        <NavItem>
                            <NavLink
                                className={classnames({ active: section === 3 })}
                                onClick={() => setSection(3)}
                                style={{ cursor: "pointer" }}
                            >
                                Statistique
                            </NavLink>
                        </NavItem>
                    </Nav>

                    <Card>
                        <CardBody>{renderBlock()}</CardBody>
                    </Card>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default withRouter(BonRetourFournisseur)